import React, { Component } from "react";
import client from "../../../utils/client";
import voucherClient from "../../../utils/api/voucherClient";
import { Link, Redirect } from "react-router-dom";
import ContentLoader from "react-content-loader";
import lodash from "lodash";
import { connect } from "react-redux";
import InlineLoader from "../../../components/InlineLoader";
import Modal from "react-bootstrap/Modal";
import bookmarkActive from "../../../assets/bookmark-active.svg";
import bookmarkInactive from "../../../assets/bookmark-inactive.svg";
import windsWatermark from "../../../assets/ic_winds_watermark.svg"
import windsLogo from "../../../assets/winds_Logo.svg"
import arrow from "../../../assets/ic_arrow.svg"
import offer from "../../../assets/ic_offer.svg"
import filterIcon from "../../../assets/filter-icon.svg";
import SubVouchers from "../../../components/SubVouchers";
import {
  fetchingVouchers,
  setVouchers,
  fetchingVoucherCategories,
  setVoucherCategories,
  selectCategoryForVouchers,
  unselectCategoryForVouchers,
  fetchingNextPage,
  addVouchers,
  setVoucherListAfterBookmarkToggle,
  onVouchersFilterClick,
  resetVoucherFilter,
} from "../actions";
import { FormattedMessage } from "react-intl";
import { onViewedPage, onFilteredVouchers } from "../../../utils/events";
import { currentlySelectedLanguage } from "../../../utils/helper";
import Iframe from "../../../components/iFrame";
import { FirebaseContext } from "../../../utils/firebase";
import EmptyState from "../../../components/EmptyState";
class VouchersList extends Component {
  static contextType = FirebaseContext;

  state = {
    isMultipleVoucherAvailable: false,
    selected: 0,
    redirect: false,
    isVoucherMaintenance: false,
    discountFilter: {
      "2-5": false,
      "6-10": false,
      "11-15": false,
    },
    customerDiscountFilter: [
      {
        "key": "2-5",
        "value": "2% - 5%"
      },
      {
        "key": "6-10",
        "value": "6% - 10%"
      },
      {
        "key": "11-15",
        "value": "11% & Above"
      },
    ],
    discountStatus: ''
  };
  componentDidMount() {
    this.props.resetFilterOnLoad()
    const { voucher_detail } = this.context;
    if (!voucher_detail) {
      this.props.initCategory();
      this.props.initVouchers(this.props.selectedCategories, this.state.discountStatus);
    } else {
      this.setState({
        isVoucherMaintenance: voucher_detail,
      });
    }

    const payload = {
      page_name: "Voucher List Page",
    };

    onViewedPage(payload);
    window.addEventListener("scroll", this.onScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  resetDiscountFilter() {
    // resetting voucher discount filter on reset button click

    // document.getElementById('discount-2-5').checked = false;
    // document.getElementById('discount-6-10').checked = false;
    // document.getElementById('discount-11-15').checked = false;

    // this.setState({discountFilter: {
    //   "2-5": false,
    //   "6-10": false,
    //   "11-15": false,
    // }})
    // this.setState({discountStatus:''})
    // this.props.initVouchers(this.props.selectedCategories, this.state.discountStatus);

  }

  onScroll = () => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
      this.props.vouchers &&
      !this.props.isFetchingNextPage &&
      this.props.nextPage
    ) {
      this.props.onPaginatedSearch(
        this.props.selectedCategories,
        this.props.nextPage,
        this.state.discountStatus
      );
    }
  };

  onChange = (event, id) => {
    let name = event.target.name
    if (event.target.checked) {
      this.props.onSelectCategory(id);
      onFilteredVouchers({ category: name });
      return;
    }

    this.props.onUnselectCategory(id);
  };

  componentDidUpdate(prevProps) {
    if (
      !lodash.isEqual(
        this.props.selectedCategories,
        prevProps.selectedCategories
      )
    ) {
      this.props.initVouchers(this.props.selectedCategories, this.state.discountStatus);
    }
  }

  Breadcrubs = (props) => {
    return (
      <div className="col-8 col-md-12">
        <small>
          <Link to="/">
            <FormattedMessage id="breadcrumbs.home" defaultMessage="Home" />
          </Link>{" "}
          /{" "}
          <strong>
            <FormattedMessage id="home.vouchers" defaultMessage="Vouchers" />
          </strong>
        </small>
      </div>
    );
  };

  render() {
    return this.context.voucher_detail ? (
      <div className="container-fluid font-proxima-nova">
        <div className="row mt-3 mb-3 mt-md-4 mb-md-4 align-items-center">
          <this.Breadcrubs />
        </div>
        <div className="row">
          <div className="col-12">
            <Iframe
              source={`${process.env.REACT_APP_BASE_URL_VOUCHER_MAINTENANCE
                }/${currentlySelectedLanguage()}`}
            ></Iframe>
          </div>
        </div>
      </div>
    ) : (
      <div className="container-fluid font-proxima-nova">
        <div className="row mt-3 mb-3 mt-md-4 mb-md-4 align-items-center">
          <this.Breadcrubs />
          <div className="col-4 text-right d-block d-md-none">
            <img src={filterIcon} alt="" className="filter-icon" />
            <button className="btn" onClick={this.props.onVouchersFilterClick}>
              <FormattedMessage id="general.filters" defaultMessage="Filters" />
            </button>

            <React.Fragment>
              <Modal
                show={this.props.isVoucherFilterModelOpen}
                onHide={this.props.onVouchersFilterClick}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <strong>Filters</strong>
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <p className="mb-3 text-uppercase font-proxima-nova-bold">
                        <FormattedMessage
                          id="order.segment"
                          defaultMessage="SEGMENT"
                        />
                      </p>
                    </div>
                  </div>
                  <this.Filters />
                </Modal.Body>
                <Modal.Footer>
                  <div className="row w-100">
                    <div className="col-6">
                      <button
                        className="w-100 btn btn-outline-primary"
                        onClick={this.props.onVouchersFilterClick}
                      >
                        <FormattedMessage
                          id="general.apply"
                          defaultMessage="Apply"
                        />
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn w-100 btn-outline-primary"
                        onClick={() => {
                          this.props.onVouchersFilterClick();
                          this.props.resetVoucherFilter();
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </Modal.Footer>
              </Modal>
            </React.Fragment>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-3 d-none d-md-block border-right w-100">
            <this.FiltersBlock />
          </div>
          <div className="col-12 col-md-9 main-content">
            {/* <div className="voucher-heading-box">
              <h3 className="voucher-heading">
                <FormattedMessage
                  id="voucher.value_for_money_vouchers"
                  defaultMessage="Value for Money Vouchers"
                />
              </h3>
              <div className="d-flex justify-content-center mb-3">
                {this.state.customerDiscountFilter.map((item, index) => {
                  return (
                    <div style={{ backgroundColor: "rgb(191 43 255)", borderRadius: "5px" }} className="d-flex flex-row-reverse mr-md-3 mr-sm-2 mr-2 p-md-1 px-md-2 p-sm-2 p-1 px-2" key={"dicount-" + index}>
                      <span className="discount-span">{item.value}</span>

                      <div className="custom-control custom-checkbox ml-auto">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={"discount-" + item.key}
                          onChange={(e) => this.handleDiscountStatusFilter(e, item.key)}
                          name={item.key}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={"discount-" + item.key}
                        ></label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div> */}
            {this.props.isFetchingVouchers ? (
              <this.VoucherShimmer />
            ) : this.props.vouchers.length === 0 ? (
              <this.NoVoucher />
            ) : (
              <this.Vouchers />
            )}
            <div className="row">
              <div className="col-12 text-center">
                {this.props.isFetchingNextPage && <InlineLoader />}
                {!this.props.nextPage && this.props.vouchers.length > 0 && (
                  <p className="font-weight-bold">No More Vouchers</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  NoVoucher = (props) => {
    return (
      <div className="empty-state">
        <EmptyState
          title={
            <FormattedMessage
              id="voucher.no-voucher"
              defaultMessage="No Voucher found."
            />
          }
          imageWidth={35}
        />
      </div>
    );
  };


  handleDiscountStatusFilter = (e) => {
    const { name } = e.target;

    this.setState(prevState => {
      return {
        discountFilter: {
          ...prevState.discountFilter,
          [name]: !prevState.discountFilter[name]
        }
      };
    })

    setTimeout(() => {
      let str = ""
      let selectedStatus = Object.entries(this.state.discountFilter).filter(([key, value]) => value === true);
      Object.values(selectedStatus).map(value => str = str.concat(value[0], "&"))
      this.setState({ discountStatus: str });
      this.props.updateDiscount(this.props.selectedCategories, this.state.discountStatus);
    }, 500)
  }


  FiltersBlock = (props) => {
    return (
      <React.Fragment>
        <div className="row mb-3 status border-bottom">
          <div className="col-6 pl-0">
            <h5 className="font-proxima-nova-bold">
              <FormattedMessage id="general.filters" defaultMessage="Filters" />
            </h5>
          </div>
          <div className="col-6 pr-0">
            <button
              className="btn btn-outline float-right"
              onClick={() => {
                this.props.resetVoucherFilter();
                this.resetDiscountFilter();
              }}
              style={{ color: "#087CD8", marginTop: "-0.5rem" }}
            >
              <FormattedMessage id="general.reset" defaultMessage="Reset" />
            </button>
          </div>
        </div>
        {/* <this.DiscountFilters/> */}
        <div className="row">
          <div className="col-12">
            <p className="mb-3 mt-3 text-uppercase font-proxima-nova-bold">
              <FormattedMessage
                id="order.segment"
                defaultMessage="SEGMENT"
              />
            </p>
          </div>
        </div>
        {/* <this.Filters /> */}
        {this.Filters()}
      </React.Fragment>
    );
  };


  DiscountFilters = (props) => {
    return (
      <React.Fragment>
        <div className="border-bottom mt-3 pb-2 status">
          <p className="text-uppercase">
            <strong>
              <FormattedMessage
                id="vouchers.discount"
                defaultMessage="Discounts"
              />
            </strong>
          </p>

          {this.state.customerDiscountFilter.map((item, index) => {
            return (
              <div className="d-flex mb-3" key={"dicount-" + index}>
                <span>{item.value}</span>

                <div className="custom-control custom-checkbox ml-auto">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id={"dicount-" + item.key}
                    onChange={(e) => this.handleDiscountStatusFilter(e, item.key)}
                    name={item.key}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor={"dicount-" + item.key}
                  ></label>
                </div>
              </div>
            );
          })}


        </div>
      </React.Fragment>
    );
  };

  Filters = (props) => {
    return (
      <React.Fragment>
        {this.props.isFetchingVoucherCategories ? (
          <div className="row">
            <div className="col-md-12">
              <ContentLoader
                height={200}
                width={200}
                speed={2}
                primaryColor="#F6F7F8"
                secondaryColor="#ecebeb"
              >
                <rect x="0" y="0" rx="2" ry="2" width="132" height="16" />
                <rect x="180" y="0" rx="2" ry="2" width="16" height="16" />
                <rect x="0" y="24" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="48" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="72" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="96" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="120" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="144" rx="2" ry="2" width="132" height="16" />
                <rect x="0" y="168" rx="2" ry="2" width="132" height="16" />
                <rect x="180" y="24" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="48" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="72" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="96" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="120" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="144" rx="2" ry="2" width="16" height="16" />
                <rect x="180" y="168" rx="2" ry="2" width="16" height="16" />
              </ContentLoader>
            </div>
          </div>
        ) : (
          <div
            style={{
              height: "450px",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {this.props.categories.map((item, index) => {
              return (
                <div className="row mt-3" key={"voucher-category-box-" + index}>
                  <div className="col-9">{item.value}</div>
                  <div className="col-3 mb-1 text-center">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={"voucher-" + item.key}
                        name={item.value}
                        checked={
                          lodash.indexOf(
                            this.props.selectedCategories,
                            item.key
                          ) > -1
                        }
                        onChange={(event) => {
                          this.onChange(event, item.key);
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={"voucher-" + item.key}
                      ></label>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  };

  VoucherShimmer = (props) => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4 d-none d-md-block">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4 d-none d-md-block">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
          <div className="col-6 col-md-4 d-none d-md-block">
            <div className="box shine mb-3 mb-md-4"></div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  getVoucherDetail = (voucher, index) => {
    if (voucher.is_internal > 0) {
      this.setState({
        isMultipleVoucherAvailable: true,
        selected: index,
        redirect: false,
      });
    } else {
      this.setState({
        isMultipleVoucherAvailable: false,
        selected: index,
        redirect: true,
      });
    }
  };

  toggleBookmark = (event, id, isBookmarked) => {
    event.preventDefault();
    event.stopPropagation();
    this.onToggleBookmark(id, isBookmarked, `/vouchers/${id}/bookmark`);
  };

  onToggleBookmark = (id, isBookmarked, url) =>
    !isBookmarked
      ? this.props.addBookmark(id, url, this.props.vouchers)
      : this.props.deleteBookmark(id, url, this.props.vouchers);

  Vouchers = (props) => {
    return (
      <React.Fragment>
        <div className="row mt-1">
          {this.props.vouchers.map((item, index) => {
            return (
              <div className="col-6 col-md-4" key={"voucher-card-" + index}>
                <div
                  style={{ cursor: "pointer", overflow: "hidden", border: "3px solid #d9d4ff" }}
                  className="card mb-4 card--carousel-item card--carousel-item--vouchers voucher-bg"
                  onClick={() => this.getVoucherDetail(item, index)}
                >
                  {
                    <img
                      src={item.bookmarked ? bookmarkActive : bookmarkInactive}
                      className="bookmark"
                      alt=""
                      onClick={(event) =>
                        this.toggleBookmark(event, item.id, item.bookmarked)
                      }
                    />
                  }

                  <div className={`card-body p-0 ${item.customer_discount !== 0 ? 'has-discount ' : 'no-discount'}`} style={{ borderRadius: "8px", position: "relative" }}>
                    <img className="winds-watermark" src={windsWatermark} alt="windsWatermark" />
                    <img className="item-logo" src={item.web_image_url} alt={item.name} style={{ position: "absolute", left: "0", top: "0", bottom: "0", right: "0", margin: "auto" }} />
                    <img className="winds-logo" src={windsLogo} alt="windsLogo" />

                    {/* <span className="delivery-type-label">
                    {item.delivery_type}
                  </span> */}
                    {/* {0 === parseInt(item.turn_around_time_in_hours) ? (
                    <span className="delivery-detail d-none d-md-block">
                      <img src={lightningIcon} alt="" />
                      Instant Delivery
                    </span>
                  ) : (
                    <span className="delivery-detail d-none d-md-block">
                      <img src={deliveryWithDelayIcon} alt="" />
                      <FormattedMessage
                        id="voucher.delivered-in"
                        defaultMessage="Delivered in"
                      />{" "}
                      {item.turn_around_time_in_hours}{" "}
                      {item.turn_around_time_in_hours > 1 ? "Hours" : "Hour"}
                    </span>
                  )} */}
                  </div>
                  {item && item.customer_discount > 0 ?

                    <div className="card-bottom d-flex justify-content-between align-items-center p-2" style={{ background: "#f3d9fe", borderRadius: "5px", position: "unset", bottom: "0", width: "100%", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}>
                      <div>
                        <h5 className="m-0 d-flex align-items-center dis-head"><img src={offer} alt="offer" width="20px" style={{ height: "auto", marginRight: "5px" }} />{item.customer_discount}% Off</h5>
                      </div>
                      <div>
                        <img src={arrow} alt="arrow" width="35px" style={{ height: "auto" }} />
                      </div>
                    </div> :
                    <></>}
                </div>
                {this.state.redirect && this.state.selected === index && (

                  <Redirect push to={`/voucher/${item.id}`} />

                )}

                {this.state.isMultipleVoucherAvailable &&
                  this.state.selected === index && (
                    <SubVouchers
                      parentId={item.id}
                      onClose={() =>
                        this.setState({ isMultipleVoucherAvailable: false })
                      }
                    />
                  )}
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };
}

function mapStateToProps(state) {
  return {
    isFetchingVoucherCategories: state.voucher.isFetchingVoucherCategories,
    categories: state.voucher.categories,
    selectedCategories: state.voucher.selectedCategories,
    isFetchingVouchers: state.voucher.isFetchingVouchers,
    vouchers: state.voucher.vouchers,
    isFetchingNextPage: state.voucher.isFetchingNextPage,
    nextPage: state.voucher.nextPage,
    isVoucherFilterModelOpen: state.voucher.isVoucherFilterModelOpen,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetFilterOnLoad: () => {
      dispatch(resetVoucherFilter());
    },
    initCategory: () => {
      dispatch(fetchingVoucherCategories());

      client.get("v1/vouchers/filters").then((response) => {
        let data = response.data.data.segment;

        dispatch(setVoucherCategories(data));
      });
    },
    initVouchers: (categories, discount) => {
      dispatch(fetchingVouchers());

      voucherClient
        .get("v3/vouchers", {
          params: {
            segment: categories.join(","),
            discount_percentage: discount
          },
        })
        .then((response) => {
          let data = response.data.data;

          let nextPageURL =
            null !== response.data.links.next &&
            new URL(response.data.links.next);

          let nextPage =
            null !== response.data.links.next &&
            nextPageURL.searchParams.get("page");

          dispatch(setVouchers(data, nextPage));
        });
    },
    updateDiscount: (categories, discount) => {
      dispatch(fetchingVouchers());

      voucherClient
        .get("v3/vouchers", {
          params: {
            segment: categories.join(","),
            discount_percentage: discount
          },
        })
        .then((response) => {
          let data = response.data.data;

          let nextPageURL =
            null !== response.data.links.next &&
            new URL(response.data.links.next);

          let nextPage =
            null !== response.data.links.next &&
            nextPageURL.searchParams.get("page");

          dispatch(setVouchers(data, nextPage));
        });
    },
    onSelectCategory: (id) => {
      dispatch(selectCategoryForVouchers(id));
    },
    onUnselectCategory: (id) => {
      dispatch(unselectCategoryForVouchers(id));
    },
    onVouchersFilterClick: () => {
      dispatch(onVouchersFilterClick());
    },
    resetVoucherFilter: () => {
      dispatch(resetVoucherFilter());
    },
    onPaginatedSearch: (categories, nextPage, discount) => {
      dispatch(fetchingNextPage());

      voucherClient
        .get("v3/vouchers", {
          params: {
            segment: categories.join(","),
            page: nextPage,
            discount_percentage: discount
          },
        })
        .then((response) => {
          let data = response.data.data;

          let nextPageURL =
            null !== response.data.links.next &&
            new URL(response.data.links.next);

          let nextPage =
            null !== response.data.links.next &&
            nextPageURL.searchParams.get("page");

          dispatch(addVouchers(data, nextPage));
        });
    },
    addBookmark: (id, url, vouchers) => {
      client
        .post(url, {})
        .then((response) => {
          dispatch(setVoucherListAfterBookmarkToggle(id, vouchers));
        })
        .catch((error) => { });
    },

    deleteBookmark: (id, url, vouchers) => {
      client
        .delete(url)
        .then((response) => {
          dispatch(setVoucherListAfterBookmarkToggle(id, vouchers));
        })
        .catch((error) => { });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VouchersList);
